import * as React from "react";

export default function Only(props: any) {
	return props.if ? <>{props.children}</> : null;
}
